var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.5312 14.75C29.5312 22.0156 24.1992 28.0508 17.2266 29.1055V18.9688H20.625L21.2695 14.75H17.2266V12.0547C17.2266 10.8828 17.8125 9.76953 19.6289 9.76953H21.4453V6.19531C21.4453 6.19531 19.8047 5.90234 18.1641 5.90234C14.8828 5.90234 12.7148 7.95312 12.7148 11.5859V14.75H9.02344V18.9688H12.7148V29.1055C5.74219 28.0508 0.46875 22.0156 0.46875 14.75C0.46875 6.72266 6.97266 0.21875 15 0.21875C23.0273 0.21875 29.5312 6.72266 29.5312 14.75Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
